import React from 'react';
import {
  Container,
  Row,
  Col,
  Form,
  Button,
} from 'react-bootstrap';

import Header from './header';
import Footer from './footer';

import {
  FaMapMarkerAlt,
  FaEnvelope,
  FaPhoneAlt,
  FaPaperPlane,
  FaClock,
  FaArrowRight,
} from 'react-icons/fa';

class ContactUs extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      name: '',
      email: '',
      message: '',
      submitted: false,
    };
  }

  handleChange = (event) => {
    const { name, value } = event.target;

    this.setState({
      [name]: value,
      submitted: false,
    });
  };

  handleSubmit = (event) => {
    event.preventDefault();

    const {
      name,
      email,
      message,
    } = this.state;

    if (!name.trim() || !email.trim() || !message.trim()) {
      return;
    }

    /*
     * Form submission logic can be connected to your
     * backend API here.
     */

    console.log({
      name,
      email,
      message,
    });

    this.setState({
      submitted: true,
      name: '',
      email: '',
      message: '',
    });
  };

  render() {
    const {
      name,
      email,
      message,
      submitted,
    } = this.state;

    return (
      <div className="contact-page">

        <Header />


        {/* ================= HERO ================= */}

        <section className="contact-hero">

          <Container>

            <Row>

              <Col
                lg={8}
                className="mx-auto text-center"
              >

                <span className="contact-eyebrow">
                  GET IN TOUCH
                </span>

                <h1>
                  Let's Start a
                  <br />
                  <span>Conversation.</span>
                </h1>

                <p>
                  Have a question, suggestion, or need assistance?
                  Our team would love to hear from you.
                </p>

                <div className="contact-hero-line" />

              </Col>

            </Row>

          </Container>

        </section>


        {/* ================= CONTACT CONTENT ================= */}

        <section className="contact-section">

          <Container>

            <Row className="g-4">

              {/* ================= CONTACT INFORMATION ================= */}

              <Col lg={5}>

                <div className="contact-info-panel">

                  <span className="contact-label">
                    CONTACT INFORMATION
                  </span>

                  <h2>
                    We're here to
                    <span> help.</span>
                  </h2>

                  <p className="contact-intro">
                    Whether you have a question about our test series,
                    preparation resources, payments, or anything else,
                    feel free to contact us.
                  </p>


                  {/* ADDRESS */}

                  <div className="contact-info-item">

                    <div className="contact-icon">
                      <FaMapMarkerAlt />
                    </div>

                    <div>

                      <span>
                        OUR ADDRESS
                      </span>

                      <h4>
                        ErwaToday.in
                      </h4>

                      <p>
                        192/2 Opposite Public Garden,
                        Car Park Stand
                        <br />
                        Sector 3A New, Infocity,
                        <br />
                        Gandhinagar, Ahmedabad,
                        Gujarat - 382016
                      </p>

                    </div>

                  </div>


                  {/* EMAIL */}

                  <div className="contact-info-item">

                    <div className="contact-icon">
                      <FaEnvelope />
                    </div>

                    <div>

                      <span>
                        EMAIL
                      </span>

                      <p className="contact-links">

                        <a href="mailto:sikandar0503@gmail.com">
                          sikandar0503@gmail.com
                        </a>

                        <br />

                        <a href="mailto:administrative@erwatoday.in">
                          administrative@erwatoday.in
                        </a>

                      </p>

                    </div>

                  </div>


                  {/* PHONE */}

                  <div className="contact-info-item">

                    <div className="contact-icon">
                      <FaPhoneAlt />
                    </div>

                    <div>

                      <span>
                        PHONE
                      </span>

                      <p>
                        <a href="tel:+919608372362">
                          +91 9608372362
                        </a>
                      </p>

                    </div>

                  </div>


                  {/* AVAILABILITY */}

                  <div className="contact-availability">

                    <FaClock />

                    <div>

                      <strong>
                        Available for assistance
                      </strong>

                      <p>
                        We aim to respond to your queries
                        as soon as possible.
                      </p>

                    </div>

                  </div>

                </div>

              </Col>


              {/* ================= CONTACT FORM ================= */}

              <Col lg={7}>

                <div className="contact-form-card">

                  <div className="contact-form-heading">

                    <div>

                      <span className="contact-label">
                        SEND A MESSAGE
                      </span>

                      <h2>
                        How can we
                        <span> help you?</span>
                      </h2>

                    </div>

                    <div className="form-icon">
                      <FaPaperPlane />
                    </div>

                  </div>


                  {submitted && (

                    <div className="success-message">

                      <strong>
                        Message received!
                      </strong>

                      <span>
                        Thank you for contacting ErwaToday.
                      </span>

                    </div>

                  )}


                  <Form onSubmit={this.handleSubmit}>

                    {/* NAME */}

                    <Form.Group
                      className="contact-form-group"
                      controlId="contactName"
                    >

                      <Form.Label>
                        Your Name
                      </Form.Label>

                      <Form.Control
                        type="text"
                        name="name"
                        value={name}
                        onChange={this.handleChange}
                        placeholder="Enter your full name"
                        required
                      />

                    </Form.Group>


                    {/* EMAIL */}

                    <Form.Group
                      className="contact-form-group"
                      controlId="contactEmail"
                    >

                      <Form.Label>
                        Email Address
                      </Form.Label>

                      <Form.Control
                        type="email"
                        name="email"
                        value={email}
                        onChange={this.handleChange}
                        placeholder="Enter your email address"
                        required
                      />

                    </Form.Group>


                    {/* MESSAGE */}

                    <Form.Group
                      className="contact-form-group"
                      controlId="contactMessage"
                    >

                      <Form.Label>
                        Your Message
                      </Form.Label>

                      <Form.Control
                        as="textarea"
                        rows={6}
                        name="message"
                        value={message}
                        onChange={this.handleChange}
                        placeholder="Tell us how we can help..."
                        required
                      />

                    </Form.Group>


                    {/* SUBMIT */}

                    <Button
                      type="submit"
                      className="contact-submit-button"
                    >

                      <span>
                        Send Message
                      </span>

                      <FaArrowRight />

                    </Button>

                  </Form>

                </div>

              </Col>

            </Row>

          </Container>

        </section>


        {/* ================= BOTTOM CTA ================= */}

        <section className="contact-bottom">

          <Container>

            <div className="contact-bottom-card">

              <div>

                <span>
                  ERWATODAY
                </span>

                <h2>
                  Preparing smarter,
                  <br />
                  performing better.
                </h2>

              </div>

              <div className="contact-bottom-text">

                <p>
                  Your questions and feedback help us
                  improve the ErwaToday experience.
                </p>

              </div>

            </div>

          </Container>

        </section>


        <Footer />


        {/* ================= PAGE STYLES ================= */}

        <style>{`

          .contact-page {
            background: #f7f9fc;
            color: #172033;
            overflow-x: hidden;
          }


          /* ================= HERO ================= */

          .contact-hero {
            padding: 105px 20px 95px;
            background:
              linear-gradient(
                135deg,
                #071a32 0%,
                #0c315c 55%,
                #1263a0 100%
              );
            color: #fff;
            position: relative;
            overflow: hidden;
          }

          .contact-hero:before {
            content: "";
            position: absolute;
            width: 420px;
            height: 420px;
            border-radius: 50%;
            border: 1px solid rgba(255,255,255,.08);
            right: -120px;
            top: -150px;
          }

          .contact-hero:after {
            content: "";
            position: absolute;
            width: 220px;
            height: 220px;
            border-radius: 50%;
            border: 1px solid rgba(255,255,255,.07);
            left: -90px;
            bottom: -100px;
          }

          .contact-eyebrow {
            display: inline-block;
            color: #8fc9ff;
            font-size: 12px;
            font-weight: 800;
            letter-spacing: 2px;
            margin-bottom: 18px;
          }

          .contact-hero h1 {
            font-size: clamp(44px, 6vw, 70px);
            font-weight: 800;
            line-height: 1.05;
            letter-spacing: -2px;
            margin-bottom: 25px;
          }

          .contact-hero h1 span {
            color: #48a8ff;
          }

          .contact-hero p {
            max-width: 650px;
            margin: auto;
            color: rgba(255,255,255,.76);
            font-size: 18px;
            line-height: 1.8;
          }

          .contact-hero-line {
            width: 65px;
            height: 4px;
            background: #1689ff;
            border-radius: 20px;
            margin: 32px auto 0;
          }


          /* ================= MAIN SECTION ================= */

          .contact-section {
            padding: 90px 20px;
            background: #f7f9fc;
          }


          /* ================= INFO PANEL ================= */

          .contact-info-panel {
            height: 100%;
            padding: 45px;
            border-radius: 24px;
            background:
              linear-gradient(
                145deg,
                #09203d,
                #0d4779
              );
            color: #fff;
            box-shadow:
              0 20px 55px rgba(10,40,75,.12);
          }

          .contact-label {
            display: inline-block;
            color: #1689ff;
            font-size: 11px;
            font-weight: 800;
            letter-spacing: 1.8px;
            margin-bottom: 14px;
          }

          .contact-info-panel .contact-label {
            color: #8fc9ff;
          }

          .contact-info-panel h2 {
            font-size: 38px;
            line-height: 1.15;
            font-weight: 800;
            margin-bottom: 18px;
          }

          .contact-info-panel h2 span {
            color: #48a8ff;
          }

          .contact-intro {
            color: rgba(255,255,255,.7);
            line-height: 1.8;
            margin-bottom: 40px;
          }


          /* ================= INFO ITEMS ================= */

          .contact-info-item {
            display: flex;
            gap: 18px;
            margin-bottom: 32px;
          }

          .contact-icon {
            flex-shrink: 0;
            width: 48px;
            height: 48px;
            border-radius: 14px;
            background: rgba(255,255,255,.1);
            color: #65b8ff;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 17px;
          }

          .contact-info-item span {
            display: block;
            font-size: 10px;
            font-weight: 800;
            letter-spacing: 1.5px;
            color: #78bfff;
            margin-bottom: 6px;
          }

          .contact-info-item h4 {
            font-size: 16px;
            margin: 0 0 5px;
            font-weight: 750;
          }

          .contact-info-item p {
            margin: 0;
            color: rgba(255,255,255,.7);
            line-height: 1.7;
            font-size: 14px;
          }

          .contact-info-item a {
            color: rgba(255,255,255,.82);
            text-decoration: none;
            transition: color .2s ease;
          }

          .contact-info-item a:hover {
            color: #65b8ff;
          }


          /* ================= AVAILABILITY ================= */

          .contact-availability {
            display: flex;
            gap: 14px;
            align-items: flex-start;
            padding: 18px;
            border-radius: 14px;
            background: rgba(255,255,255,.07);
            margin-top: 15px;
          }

          .contact-availability > svg {
            color: #65b8ff;
            margin-top: 3px;
          }

          .contact-availability strong {
            display: block;
            font-size: 13px;
            margin-bottom: 4px;
          }

          .contact-availability p {
            margin: 0;
            color: rgba(255,255,255,.6);
            font-size: 12px;
            line-height: 1.5;
          }


          /* ================= FORM CARD ================= */

          .contact-form-card {
            background: #fff;
            border: 1px solid #e5ebf2;
            border-radius: 24px;
            padding: 45px;
            box-shadow:
              0 20px 55px rgba(20,42,70,.07);
          }

          .contact-form-heading {
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
            margin-bottom: 35px;
          }

          .contact-form-heading h2 {
            font-size: 36px;
            font-weight: 800;
            line-height: 1.15;
            margin: 0;
          }

          .contact-form-heading h2 span {
            color: #1689ff;
          }

          .form-icon {
            width: 52px;
            height: 52px;
            border-radius: 15px;
            background: #eaf5ff;
            color: #1689ff;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 18px;
          }


          /* ================= FORM ================= */

          .contact-form-group {
            margin-bottom: 23px;
          }

          .contact-form-group label {
            display: block;
            color: #263247;
            font-size: 13px;
            font-weight: 700;
            margin-bottom: 9px;
          }

          .contact-form-group .form-control {
            border: 1px solid #dce3ec;
            border-radius: 12px;
            min-height: 48px;
            padding: 12px 15px;
            font-size: 14px;
            color: #172033;
            box-shadow: none;
            transition:
              border-color .2s ease,
              box-shadow .2s ease;
          }

          .contact-form-group textarea.form-control {
            min-height: 145px;
            resize: vertical;
          }

          .contact-form-group .form-control::placeholder {
            color: #a2adbc;
          }

          .contact-form-group .form-control:focus {
            border-color: #1689ff;
            box-shadow:
              0 0 0 3px rgba(22,137,255,.1);
          }


          /* ================= BUTTON ================= */

          .contact-submit-button {
            width: 100%;
            min-height: 52px;
            border: none;
            border-radius: 12px;
            background:
              linear-gradient(
                135deg,
                #087ee8,
                #1263a0
              );
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 12px;
            font-size: 14px;
            font-weight: 700;
            box-shadow:
              0 10px 25px rgba(22,137,255,.2);
            transition: all .2s ease;
          }

          .contact-submit-button:hover {
            transform: translateY(-2px);
            box-shadow:
              0 14px 30px rgba(22,137,255,.28);
          }


          /* ================= SUCCESS ================= */

          .success-message {
            display: flex;
            flex-direction: column;
            gap: 3px;
            padding: 15px 18px;
            border-radius: 12px;
            background: #ecfdf3;
            border: 1px solid #c8f0d8;
            color: #187044;
            margin-bottom: 25px;
            font-size: 13px;
          }


          /* ================= BOTTOM CTA ================= */

          .contact-bottom {
            padding: 10px 20px 100px;
            background: #f7f9fc;
          }

          .contact-bottom-card {
            padding: 55px 60px;
            border-radius: 24px;
            background: #fff;
            border: 1px solid #e5ebf2;
            display: flex;
            align-items: center;
            justify-content: space-between;
            gap: 40px;
          }

          .contact-bottom-card > div:first-child > span {
            color: #1689ff;
            font-size: 11px;
            font-weight: 800;
            letter-spacing: 2px;
          }

          .contact-bottom-card h2 {
            margin: 10px 0 0;
            font-size: 32px;
            line-height: 1.15;
            font-weight: 800;
          }

          .contact-bottom-text {
            max-width: 350px;
          }

          .contact-bottom-text p {
            color: #718096;
            line-height: 1.8;
            margin: 0;
          }


          /* ================= MOBILE ================= */

          @media (max-width: 767px) {

            .contact-hero {
              padding: 75px 20px;
            }

            .contact-hero h1 {
              font-size: 43px;
            }

            .contact-hero p {
              font-size: 16px;
            }

            .contact-section {
              padding: 60px 15px;
            }

            .contact-info-panel,
            .contact-form-card {
              padding: 30px 22px;
              border-radius: 20px;
            }

            .contact-info-panel h2,
            .contact-form-heading h2 {
              font-size: 30px;
            }

            .contact-form-heading {
              gap: 15px;
            }

            .form-icon {
              width: 44px;
              height: 44px;
              flex-shrink: 0;
            }

            .contact-bottom {
              padding: 0 15px 70px;
            }

            .contact-bottom-card {
              padding: 35px 25px;
              display: block;
            }

            .contact-bottom-card h2 {
              font-size: 28px;
              margin-bottom: 20px;
            }

          }

        `}</style>

      </div>
    );
  }
}

export default ContactUs;